export default __webpack_public_path__ + "static/media/urine.e92ef308.svg";